export default __webpack_public_path__ + "static/media/letter-template.3fb60bde.svg";